import { JsonLd } from 'src/components/JsonLd'
import type { WebPage } from 'schema-dts'
import Seo from 'src/components/Seo'
import { absoluteSeoUrl, seoDescription, seoText, seoTitle } from 'src/functions/seo'
import shopInfos from 'template/infos'

interface Props {
  title?: string
  description?: string
  image?: string
  imageAlt?: string
  renderMetadata?: boolean
}

const HomeSeo = ({ title, description, image, imageAlt, renderMetadata = true }: Props) => {
  const name = seoTitle(title || shopInfos.title)
  const descriptionText = seoDescription(description, shopInfos.description)
  const url = absoluteSeoUrl('/')

  return <>
    {renderMetadata && <Seo title={name} appendSiteName={false} description={descriptionText} canonical='/' image={image} imageAlt={imageAlt} />}
    <JsonLd<WebPage> item={{
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${url}#webpage`,
      url,
      name,
      description: descriptionText,
      isPartOf: { '@id': `${shopInfos.url.replace(/\/$/, '')}#website` },
      inLanguage: shopInfos.locale.replace('_', '-'),
      ...(image ? {
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: absoluteSeoUrl(image),
          ...(seoText(imageAlt) ? { caption: seoText(imageAlt) } : {}),
        },
      } : {}),
    }} />
  </>
}

export default HomeSeo
